import type { ProductDiscountedPriceFragment } from '@/queries/fragments/ProductFragment';

const isFreeRing = (
  discountedProductPrice: ProductDiscountedPriceFragment,
): boolean => {
  const originalAmount: number | null =
    discountedProductPrice.originalPrice?.amount ?? null;
  const discountedAmount: number | null =
    discountedProductPrice.discountedPrice?.amount ?? null;
  const parsedPrice = Number(originalAmount);

  if (!originalAmount || !discountedAmount) return true;

  return Math.max(parsedPrice - (originalAmount - discountedAmount), 0) === 0;
};

export default isFreeRing;
